import { getConfigObject, useMutationWithLoading } from "../../utils/utils";
import { Role, RolesAndPrivilegesControllerApi } from "../../services";

/**
 * @author Atish Bagate
 */
interface Params {
  role: Role;
  xTENANTID?: string;
}
export const useUpdateRole = () =>
  useMutationWithLoading(async (params: Params) =>
    new RolesAndPrivilegesControllerApi(getConfigObject()).updateRole(
      params?.role,
      params?.xTENANTID
    )
  );
